export default function Loader() {
  return (
    <span>
      <img
        className="w-6 animate-loading mt-[3vh] mb-[3vh]"
        src={"https://freesvg.org/img/1544764567.png"}
        // TODO: change graphic later
      />
    </span>
  );
}
